import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_WHATSNEW = createActionTypes('FETCH_WHATSNEW');
export const GET_WHATSNEW = createActionTypes('GET_WHATSNEW');
export const CREATE_WHATSNEW = createActionTypes('CREATE_WHATSNEW');
export const UPDATE_WHATSNEW = createActionTypes('UPDATE_WHATSNEW');
export const DELETE_WHATSNEW = createActionTypes('DELETE_WHATSNEW');
